
import {combineLatest as observableCombineLatest,  Observable ,  Subscription } from 'rxjs';

import {filter} from 'rxjs/operators';
import {
    Component, HostListener,
    Renderer2, ElementRef,
    ViewEncapsulation, Inject, OnDestroy, AfterViewInit, OnInit, ViewChild
} from '@angular/core';
import { trigger, transition, animate, state, style } from '@angular/animations';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { Router } from "@angular/router";
import { DialogFullScreenComponentContent } from '../../../models/dialogs/dialog-full-screen';
import { Store } from '@ngrx/store';
import { AppState } from '../../../interfaces/app-state.interface';
import { NotificationsAction } from '../../../state-management/notifications/notifications.actions';


import { Notification } from '../../../models/communication/Notification.model';

@Component({
    selector: 'notifications-overlay-list',
    templateUrl: 'notifications-overlay-list.component.html',
    styleUrls: ['notifications-overlay-list.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class NotificationsOverlayList extends DialogFullScreenComponentContent implements OnDestroy, OnInit {


    public notificationsItens: Array<Notification> = [];
    public unreadnotifications: Array<Notification> = [];
    public attendences: Array<any> = [];
    private activeFilter: number = 0; // 0 - Todas 1 - Não lidas
    public notifications: Array<Notification> = [];
    private storeSubscription: Subscription;
    public activeNotification: number;

    @ViewChild('header', {static: true}) headerElement: ElementRef;

    constructor(
        private _elRef: ElementRef,
        private _ren: Renderer2,
        private _rT: Router,

        private dialogReference: MatDialogRef<NotificationsOverlayList>,
        private _element: ElementRef,
        private store: Store<AppState>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        super(_element);

        this.storeSubscription = observableCombineLatest(
            this.store.select(s => s.notifications),
            this.store.select(s => s.salesforce)
        ).pipe(
        filter(([notifications, salesforce]) => !notifications.pending && !salesforce.pending))
        .subscribe(([notifications, salesforce]) => {
            this.attendences = [...salesforce.attendences].map(item => {
                return {
                    body: `Avalie seu atendimento sobre "${item.subject}"`,
                    details: null,
                    messageID: null,
                    readStatus: 0,
                    // Deixar sem uma data temporariamente enquanto implementação não ocorre em back
                    sendDate: '',
                    attendence: item
                };
            });
            this.notificationsItens = [...[], ...this.attendences, ...notifications.notifications];
            this.unreadnotifications = this.notificationsItens.filter(item => item && (item.readStatus == 0));
            if(this.activeFilter == 0 ) {
                this.notifications = this.notificationsItens;
            }
            if(this.data) {
                this.activeNotification = this.data.messageID;
            }
        });

        // this.store.dispatch({ type: NotificationsAction.getNotifications });
    }

    /**
     * Setar o filtro de todas as notificações
     * @param event Evento de clique do mouse.
     */
    setFilterAll(event: MouseEvent) {
        this.activeFilter = 0;
        this.notifications = this.notificationsItens;
        let element: HTMLElement = (<HTMLElement>event.target);
        const filters = element.parentElement.querySelectorAll('.btn-filter');
        Array.from(filters).forEach(item => item.classList.remove('active'));
        element.classList.add('active');
    }

    /**
     * Setar o filtro de notificações não lidas
     * @param event Evento de clique do mouse.
     */
    setFilterUnread(event: MouseEvent) {
        this.activeFilter = 1;
        this.notifications = this.unreadnotifications;
        let element: HTMLElement = (<HTMLElement>event.target);
        const filters = element.parentElement.querySelectorAll('.btn-filter');
        Array.from(filters).forEach(item => item.classList.remove('active'));
        element.classList.add('active');
    }


    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }

    ngOnInit() {
        super.ngOnInit();

    }

    /**
     * Fechar o overlay
     */
    dispose(){
        this.headerElement.nativeElement.style.position = "absolute";
        super.close(this.dialogReference, null);
    }
}
